// extracted by mini-css-extract-plugin
export var dealRoom = "styles-module--dealRoom--+QUvY";
export var noPadding = "styles-module--no-padding--VSoQn";
export var offerRoomContentBlock = "styles-module--offer-room-content-block--kk2Cs";
export var offerRoomQuote = "styles-module--offer-room-quote--gluDG";
export var primary = "#06004d";
export var quoteBlock = "styles-module--quote-block--c8dTV";
export var secondary = "#4dafd7";
export var visible = "styles-module--visible--Ttkiv";